import type { RouteRecordRaw } from 'vue-router'

import HomePage from '../pages/HomePage.vue'

import { AppRoutes } from '@/enums/app-routes.enum.ts'

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang/home',
    component: HomePage,
    name: AppRoutes.HOME,
  }
]

export default routes
